import { SortingDirection } from '@core/services/sorting/sorting.models'
import { DEFAULT_QUERY_PAGING, getDateFromCurrent, getISODate } from '@core/utils/main'
import { FilterName } from '@features/marketable/marketable-packages/marketable-packages.constants'
import { FilterName as MatchFilterName } from '../data-publishing/data-publishing.enums'

export const MATCH_DEFAULT_AUTOCOMPLETE_FILTERS = {
  [MatchFilterName.MatchPeriod]: {
    start: getISODate(getDateFromCurrent(-1), false, true),
  },
}

export const MARKETABLE_DEFAULT_AUTOCOMPLETE_LAZY_PARAMS = {
  ...DEFAULT_QUERY_PAGING(),
  sorting: {
    column: FilterName.InsertDateTime,
    direction: SortingDirection.Desc,
  },
}

export const MATCH_DEFAULT_AUTOCOMPLETE_LAZY_PARAMS = {
  ...DEFAULT_QUERY_PAGING(20),
  sorting: {
    column: 'date',
    direction: SortingDirection.Asc,
  },
}

export const SALES_PARENT_ID = {
  3: 2,
}

export const SALES_TOOLTIP = {
  3: 'MTR_COMMON_PORTAL_REQUIRED',
}

export const SALE_CONTENT_PERMISSION_ID = 3
